import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { Observable } from 'rxjs';
import { IndicadoresResponse } from './models/indicadores.model';

@Injectable()
export class IndicadoresRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.INDICADORES);
  }

  getIndicadores(indicadores: string[], dataInicial?: string, dataFinal?: string): Observable<IndicadoresResponse> {
    let url = `${this.basePath}?indicadores=${indicadores.join(', ')}`;

    if (dataInicial) url += `&dataInicial=${dataInicial}`;
    if (dataFinal)   url += `&dataFinal=${dataFinal}`;

    return this.customClient.get<IndicadoresResponse>(url);
  }
}
